import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const QuickCreate = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
